import React from "react";
import { Table } from "reactstrap";
import { SimpleRow } from "../../../../layout/Table/SimpleRow";
import {
  TRANSLATED_TICKET_TYPES,
  TRANSLATED_TICKETS_STATUSES,
  TRANSLATED_TICKETS_SUBJECTS,
  TRANSLATED_TICKET_PRODUCT_REFERENCES,
} from "../../../../../config/constants";
import moment from 'moment';

function TicketDetailsTable(props) {
  const { ticket } = props;

  if (! ticket || ! ticket.id) {
    return <Table className="align-items-center table-flush" responsive striped>
      <tbody>
      <SimpleRow translationKey="messages.no_data" value=""/>
      </tbody>
    </Table>
  }

  return (
    <Table className="align-items-center table-flush" responsive striped>
      <tbody>
      <SimpleRow translationKey="components.pages.clients.tickets.table.organization"
                 value={ticket.organization ? ticket.organization.name : ticket.organization_name}/>
      <SimpleRow translationKey="components.pages.clients.tickets.table.user" value={ticket.organization ? `${ticket.user.first_name} ${ticket.user.last_name}` : ticket.user_initials}/>
      <SimpleRow translationKey="components.pages.clients.tickets.table.email" value={ticket.email}/>
      <SimpleRow translationKey="components.pages.clients.tickets.table.subject" value={TRANSLATED_TICKETS_SUBJECTS[ticket.subject]}/>
      <SimpleRow translationKey="components.pages.clients.tickets.table.type" value={TRANSLATED_TICKET_TYPES[ticket.type]}/>
      <SimpleRow translationKey="components.pages.clients.tickets.table.product_reference" value={TRANSLATED_TICKET_PRODUCT_REFERENCES[ticket.product_reference]}/>
      <SimpleRow className="td-overflow-tickets-details" translationKey="components.pages.clients.tickets.table.message" value={ticket.message}/>
      <SimpleRow className="td-overflow-tickets-details" translationKey="components.pages.clients.tickets.table.reason" value={ticket.reason}/>
      <SimpleRow translationKey="components.pages.clients.tickets.table.created_at" value={moment(ticket.created_at).format('LLL')}/>
      <SimpleRow
        translationKey="components.pages.clients.tickets.table.status"
        value={TRANSLATED_TICKETS_STATUSES[ticket.status]}/>
      </tbody>
    </Table>
  );
}

export { TicketDetailsTable };
